import {
  AUTH_ADMIN,
  AUTH_INVENTORY_CONTROLLER,
  AUTH_LP,
  AUTH_SPV_HUB,
} from 'middleware/privateRoute'
import { AppDispatchType, RootStateType } from 'store'
import { GetSoApprovalRequestType } from 'utils/apiList/supplyOrderApproval'
import { fetchGetSupplyOrderApproval } from './supplyOrderApprovalAsyncThunk'
import { setQueryData } from './supplyOrderApprovalSlice'

const getStatusFromAuthorities = (
  authorities: { name: string }[],
  currentStatus?: string,
): string | undefined => {
  if (currentStatus) return currentStatus

  const auth = authorities.find(
    (item) =>
      item.name === AUTH_INVENTORY_CONTROLLER ||
      item.name === AUTH_ADMIN ||
      item.name === AUTH_SPV_HUB ||
      item.name === AUTH_LP,
  )

  if (!auth) return undefined
  if (auth.name === AUTH_INVENTORY_CONTROLLER || auth.name === AUTH_ADMIN) {
    return 'WAITING_APPROVAL'
  }
  if (auth.name === AUTH_SPV_HUB) {
    return 'COMPLETED'
  }
  if (auth.name === AUTH_LP) {
    return 'IN_REVIEW'
  }
  return undefined
}

export const actSetQuery =
  (paramsQuery: GetSoApprovalRequestType) =>
  (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const {
      auth: { userData },
      supplyOrderApproval: { queryData: prevQuery = {} },
    } = getState()

    const status =
      paramsQuery?.status || getStatusFromAuthorities(userData.authorities, prevQuery?.status)

    const date =
      paramsQuery?.date ?? paramsQuery?.date_update ?? prevQuery.date ?? prevQuery.date_update

    let dateFields: Partial<GetSoApprovalRequestType> = {}
    if (date) {
      if (status === 'WAITING_LP') {
        dateFields = { date_update: date, date: '' }
      } else {
        dateFields = { date, date_update: '' }
      }
    } else {
      dateFields = { date: '', date_update: '' }
    }

    const nextQuery: GetSoApprovalRequestType = {
      ...prevQuery,
      ...paramsQuery,
      status,
    }

    dispatch(setQueryData(nextQuery))
    dispatch(fetchGetSupplyOrderApproval({ ...nextQuery, ...dateFields }))
  }
